export function validateVoiceMenu(password) {
    const trimmed = password.trim();
    if (trimmed.length === 0) {
        return null;
    }
    if (!trimmed.match(/^[0-9]*$/)) {
        return 'Код должен состоять из цифр';
    }
    return null;
}
export function validatePhone(phone) {
    const trimmed_phone = phone.trim();
    if (trimmed_phone.length === 0) {
        return 'Укажите доверенный телефон';
    }
    if (!trimmed_phone.match(/^([ \s()+-]*([0-9][\s()+-]*){6,20})/)) {
        return 'Неверный формат телефона';
    }
    return null;
}
